import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

//########## BEGIN 3rd-party libraries ############
import rtt from 'v-runtime-template'
import PortalVue from 'portal-vue'
//########## END 3rd-party libraries ############


//################ BEGIN Data imports #################
import Data from 'tivigi/src/components/data/Data/Data'
import DataFeaturesInMapExtent from 'tivigi/src/components/gis/data/DataFeaturesInMapExtent/DataFeaturesInMapExtent'
import DataMap from 'tivigi/src/components/gis/data/DataMap/DataMap'
import DataMapLayer from 'tivigi/src/components/gis/data/DataMapLayer/DataMapLayer'
import DataJsonFetch from 'tivigi/src/components/data/DataJsonFetch/DataJsonFetch'
//################ END Data imports #################


//############## BEGIN Tivigi components ###############
//import AnalogGauge from 'tivigi/src/components/charts/AnalogGauge/AnalogGauge'
import Collapsible from 'tivigi/src/components/Collapsible/Collapsible'
import DropdownButton from 'tivigi/src/components/DropdownButton/DropdownButton'
import DropdownMenu from 'tivigi/src/components/DropdownMenu/DropdownMenu'

import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'
import FullscreenButton from 'tivigi/src/components/FullscreenButton/FullscreenButton'
import JsonView from 'tivigi/src/components/JsonView/JsonView'
import Modal from 'tivigi/src/components/Modal/Modal'
//import PopupMenu from 'tivigi/src/components/PopupMenu/PopupMenu'
import ProgressBar from 'tivigi/src/components/ProgressBar/ProgressBar'
import RangeSlider from 'tivigi/src/components/RangeSlider/RangeSlider'
import ScrollSensor from 'tivigi/src/components/ScrollSensor/ScrollSensor'
import ScrollMenu from 'tivigi/src/components/ScrollMenu/ScrollMenu'
import SidebarPanel from 'tivigi/src/components/SidebarPanel/SidebarPanel'
import Slide from 'tivigi/src/components/Slideshow/Slide'
import Slideshow from 'tivigi/src/components/Slideshow/Slideshow'
import SmartButton from 'tivigi/src/components/SmartButton/SmartButton'
import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import Toolbar from 'tivigi/src/components/Toolbar/Toolbar'
import Tree from 'tivigi/src/components/Tree/Tree'
//############## END Tivigi components ###############

//######################## BEGIN tivigi GIS imports ###########################
import ActiveLayers from 'tivigi/src/components/gis/ActiveLayers/ActiveLayers'
//import AttributesTable from 'tivigi/src/components/gis/AttributesTable/AttributesTable'
import FeaturesByPropertyGroupTable from '../storymap/FeaturesByPropertyGroupTable/FeaturesByPropertyGroupTable'
import FeatureInfoTool from 'tivigi/src/components/gis/FeatureInfoTool/FeatureInfoTool'
//import FeatureHighlightTool from 'tivigi/src/components/gis/FeatureHighlightTool/FeatureHighlightTool'
//import FeatureSelectTool from 'tivigi/src/components/gis/FeatureSelectTool/FeatureSelectTool'
import LayerLegend from 'tivigi/src/components/gis/LayerLegend/LayerLegend'
import LayerMetadataPanel from 'tivigi/src/components/gis/LayerMetadataPanel/LayerMetadataPanel';
import LayerTree from 'tivigi/src/components/gis/LayerTree/LayerTree'
import LocationInput from 'tivigi/src/components/gis/LocationInput/LocationInput'
import LocationSearch from 'tivigi/src/components/gis/LocationSearch/LocationSearch'
import LocationSearch2 from 'tivigi/src/components/gis/LocationSearch2/LocationSearch2'
import MapLoadingProgressBar from 'tivigi/src/components/gis/MapLoadingProgressBar/MapLoadingProgressBar'
import MapOverlay from 'tivigi/src/components/gis/MapOverlay/MapOverlay'
import MapPrint from 'tivigi/src/components/gis/MapPrint/MapPrint'
import MapScale from 'tivigi/src/components/gis/MapScale/MapScale'
import MeasureTool from 'tivigi/src/components/gis/MeasureTool/MeasureTool'
import MouseCoordinatesTool from 'tivigi/src/components/gis/MouseCoordinatesTool/MouseCoordinatesTool'
import MyLocationTool from 'tivigi/src/components/gis/MyLocationTool/MyLocationTool'
import OlMap from 'tivigi/src/components/gis/OlMap/OlMap'
import SetMapExtentTool from 'tivigi/src/components/gis/SetMapExtentTool/SetMapExtentTool'
import StyleSwitcher from 'tivigi/src/components/gis/StyleSwitcher/StyleSwitcher'
import LayerVisibilityCheckbox from 'tivigi/src/components/gis/LayerVisibilityCheckbox/LayerVisibilityCheckbox'
//######################## END tivigi GIS imports ###########################


//################### BEGIN GOAT-related ####################
import LayerZoomFilter from '../../components/goat/LayerZoomFilter/LayerZoomFilter'
import AccessibilityHeatmap from '../../components/goat/AccessibilityHeatmap/AccessibilityHeatmap'
import ClosableWindow from '../goat/ClosableWindow/ClosableWindow';
import ConfigMenu from '../goat/ConfigMenu/ConfigMenu';
import IsochroneInfoPanel from '../goat/IsochroneInfoPanel/IsochroneInfoPanel';
import IsochroneTool from '../goat/IsochroneTool/IsochroneTool';
//################### END GOAT-related ####################

//################## BEGIN Storymap-related ###################
import DataFeaturePropertySum from '../../components/storymap/DataFeaturePropertySum/DataFeaturePropertySum'
import FeatureListItem from '../../components/storymap/FeatureListItem/FeatureListItem'
import List from '../../components/storymap/List/List'
import StorymapLayout from '../StorymapLayout/StorymapLayout'
import TwoPanelLayout from "../TwoPanelLayout/TwoPanelLayout"
//################## END Storymap-related ###################

//################ BEGIN Statistikmonitor 2 ################
import SM2Basismodul from '../../components/Statistikmonitor2/Basismodul/Basismodul'
import SM2StrukturelleSituation from '../../components/Statistikmonitor2/StrukturelleSituation/StrukturelleSituation'
import SM2Dynamik from '../../components/Statistikmonitor2/Dynamik/Dynamik'
import SM2Metropolregionen from '../../components/Statistikmonitor2/Metropolregionen/Metropolregionen'
import SM2StrukturGrafik from '../../components/Statistikmonitor2/StrukturGrafik/StrukturGrafik'
import SM2StrukturTabelle from '../../components/Statistikmonitor2/StrukturTabelle/StrukturTabelle'
//################ END Statistikmonitor 2 ################

//################ BEGIN Statistikmonitor 3 ################
import SM3Absolut from '../Statistikmonitor3/Absolutindikatoren/Absolutindikatoren'
import SM3Dynamik from '../Statistikmonitor3/Dynamik/Dynamik'
import SM3Top from '../Statistikmonitor3/Topindikatoren/Topindikatoren'
import SM3Strukturindikatoren from '../Statistikmonitor3/Strukturindikatoren/Strukturindikatoren'
import SM3Startseite from '../Statistikmonitor3/Startseite/Startseite'
import SM3Frame from '../Statistikmonitor3/SM3Frame/SM3Frame'
//################ END Statistikmonitor 3 ################


import NavbarButton from "../NavbarButton/NavbarButton"
import * as dataStore from "../../dataStore"

// NOTE: 
// For a still unknown reason, RemoteTemplateComponent can not be used in dynamic templates if is is
// imported here locally. Thus, We import and register it globally in main.ts.

// import RemoteTemplateComponent from '../RemoteTemplateComponent/RemoteTemplateComponent'


import WithRender from './DynamicTemplateComponent.html'

Vue.use(PortalVue)

@WithRender
@Component({

    name: "DynamicTemplateComponent",
    components: {
        rtt,

        //############## BEGIN Data components ################
        Data,
        DataFeaturesInMapExtent,
        
        DataMap,
        DataMapLayer,
     
        DataJsonFetch,        
        //############## END Data components ################

        //############## BEGIN GIS components ################
        
        ActiveLayers,        
       // FeatureHighlightTool,
        FeatureInfoTool,        
        
     //   FeatureSelectTool,
        FeaturesByPropertyGroupTable,                
        LayerLegend,
        LayerMetadataPanel,
        LayerTree,
        LayerVisibilityCheckbox,
        
        LocationInput,
        LocationSearch,   
        LocationSearch2,     
        MapLoadingProgressBar,        
        MapOverlay,        
        MapPrint,
        MapScale,        
        MeasureTool,
        MouseCoordinatesTool,
        MyLocationTool,   
        OlMap,    
        SetMapExtentTool,        
        StyleSwitcher,        
        //############## END GIS components ################

        //################# BEGIN Misc tivigi components #############
      
        //AttributesTable,
        Collapsible,
        DropdownButton,
        DropdownMenu,
        
        FloatingWindow,        
        FullscreenButton,
        JsonView,
        
        
        Modal,
        NavbarButton,
      //  PopupMenu,
        ProgressBar,
        RangeSlider,
        ScrollMenu,
        ScrollSensor,
        SidebarPanel,
        Slide,
        
        Slideshow,
        SmartButton,
        Superbutton,
        Toolbar,
        Tree,
        
        //################# END Misc tivigi components #############

        //################ BEGIN Storymap ##############
        DataFeaturePropertySum,
        
        FeatureListItem,
        List,        
        TwoPanelLayout,
        StorymapLayout,
        //################ END Storymap ##############


        //############# BEGIN GOAT-related #############
        AccessibilityHeatmap,
        LayerZoomFilter,
        ClosableWindow,
        ConfigMenu,
        IsochroneInfoPanel,
        IsochroneTool,
        //############# END GOAT-related #############

        //############ BEGIN Statistikmonitor 2 ###########   
        SM2Basismodul,
        SM2StrukturelleSituation,
        SM2StrukturTabelle,
        SM2StrukturGrafik,
        SM2Dynamik,
        SM2Metropolregionen,
        //############ END Statistikmonitor 2 ###########

        //############ BEGIN Statistikmonitor 3 ###########   
        SM3Absolut,
        SM3Dynamik,
        SM3Frame,
        SM3Startseite,
        SM3Top,
        SM3Strukturindikatoren,
        //############ END Statistikmonitor 3 ###########   
        
    },
})
export default class ProcessWireComponent extends Vue {

    @Prop({ default: "" })
    template!: string


    local: any = {}

    get global() {
        return dataStore.store
    }


    get showNavbar() {
        return dataStore.store.showNavbar
   
    }

    set showNavbar(newval : any) {
        
        dataStore.store.showNavbar = newval
    }

    @Watch('template')
    onTemplateChange() {
        this.local = {}
    }


   

    tryToGet(rootObject: any, path : string, fallback: any) {

        if (rootObject === undefined) {
            return undefined
        }

        let pathPieces = path.split('.')
    
        let obj = rootObject        
    
        for(let piece of pathPieces) {
    
            // TODO: 1 Add support for arrays
    
            if (obj[piece] != undefined) {
                obj = obj[piece]
            }
            else {
                return fallback
            }
        }
    
        return obj
    }   
}